// Reducer for updating the AccountState from Waitlist/Waitlist actions

import { AccountState } from '../../api/waitlist/waitlist-api'
import {
  storeWaitlistPopupHasBeenShown,
  storeWhitelistPopupHasBeenShown,
} from '../../api/waitlist/waitlist-localstorage'
import { createWhitelistEvent } from 'user-events-segment'

export interface AccountStateAction {
  type:
    | 'connected-account'
    | 'fetched-account-state'
    | 'ignored-whitelist'
    | 'close-deny-popup'
    | 'claimed-whitelist'
    | 'ignored-add-contact'
    | 'added-contact'
    | 'clicked-join-waitlist'
    | 'ignored-waitlist'
    | 'close-deny-popup-waitlist'
    | 'registered-zealy'
    | 'updated-zealy-rank'
    | 'received-xp-bonus'
    | 'closed-congrats-xp-popup'
  data?: any
  address?: string
  contactType?: ('email' | 'discord' | 'twitter') | undefined
  contact?: string
  zealyId?: string
  zealyRank?: number
  newState?: AccountState
}

export function accountStateReducer(
  state: AccountState,
  action: AccountStateAction
): AccountState {
  switch (action.type) {
    case 'connected-account': {
      return {
        ...state,
        address: action.address!,
      }
    }
    case 'fetched-account-state': {
      return action.newState!
    }
    case 'ignored-whitelist': {
      storeWhitelistPopupHasBeenShown(state.address)
      createWhitelistEvent().ignored_whitelist_offer()
      return {
        ...state,
        whitelistState: {
          ...state.whitelistState!,
          offerPopupShown: true,
          showDenyPopup: true,
        },
      }
    }
    case 'close-deny-popup': {
      return {
        ...state,
        whitelistState: {
          ...state.whitelistState!,
          showDenyPopup: false,
        },
      }
    }
    case 'claimed-whitelist': {
      storeWhitelistPopupHasBeenShown(state.address)
      createWhitelistEvent().claimed_whitelist_offer()
      return {
        ...state,
        whitelistState: {
          ...state.whitelistState!,
          claimed: true,
          offerPopupShown: true,
          showContactPopup: true,
        },
      }
    }
    case 'ignored-add-contact': {
      storeWhitelistPopupHasBeenShown(state.address)
      createWhitelistEvent().ignored_add_contact()
      return {
        ...state,
        whitelistState: {
          ...state.whitelistState!,
          showContactPopup: false,
        },
      }
    }
    case 'added-contact': {
      storeWhitelistPopupHasBeenShown(state.address)
      createWhitelistEvent().added_contact(action.contactType!, action.contact!)
      return {
        ...state,
        whitelistState: {
          ...state.whitelistState!,
          contactAdded: true,
        },
      }
    }
    case 'clicked-join-waitlist': {
      storeWaitlistPopupHasBeenShown(state.address)
      createWhitelistEvent().clicked_join_waitlist()
      return {
        ...state,
        waitlistState: {
          ...state.waitlistState,
          offerPopupShown: true,
        },
      }
    }
    case 'ignored-waitlist': {
      storeWaitlistPopupHasBeenShown(state.address)
      createWhitelistEvent().ignored_waitlist_offer()
      return {
        ...state,
        waitlistState: {
          ...state.waitlistState,
          offerPopupShown: true,
          showDenyPopup: true,
        },
      }
    }
    case 'close-deny-popup-waitlist': {
      return {
        ...state,
        waitlistState: {
          ...state.waitlistState,
          showDenyPopup: false,
        },
      }
    }
    case 'registered-zealy': {
      storeWaitlistPopupHasBeenShown(state.address)
      createWhitelistEvent().registered_zealy()
      return {
        ...state,
        onWaitlist: true,
        waitlistState: {
          ...state.waitlistState,
          offerPopupShown: true,
          rank: action.zealyRank!,
        },
      }
    }
    case 'updated-zealy-rank': {
      return {
        ...state,
        onWaitlist: true,
        waitlistState: {
          ...state.waitlistState,
          offerPopupShown: true,
          rank: action.zealyRank!,
        },
      }
    }
    case 'received-xp-bonus': {
      createWhitelistEvent().received_zealy_xp_bonus()
      return {
        ...state,
        waitlistState: {
          ...state.waitlistState,
          offerPopupShown: true,
          receivedXpBonus: true,
          showXpBonusCongrats: true,
        },
      }
    }
    case 'closed-congrats-xp-popup': {
      return {
        ...state,
        waitlistState: {
          ...state.waitlistState,
          showXpBonusCongrats: false,
        },
      }
    }
  }
}
